// extracted by mini-css-extract-plugin
module.exports = {"RemindPassword":"style_RemindPassword__72BSG","Title":"style_Title__1H9w6","Input":"style_Input__3JHo7","SubTitle":"style_SubTitle__19u4L","Content":"style_Content__38bDn"};